import React, { FC, ReactNode, useContext, useMemo } from 'react';

import { WithTranslation } from 'react-i18next';
import TertiaryButton from '../../buttons/TertiaryButton';
import Upload, { UploadProps } from '../_Upload';
import { StyledUploadIcon } from './UploadButton.styles';
import FormColContext from '../_FormColContext';

export interface UploadButtonProps extends Omit<UploadProps, 'children'> {
  children?: ReactNode;
  multiple?: UploadProps['multiple'];
}

const UploadButtonDefaultProps = {
  multiple: true,
};

/**
 * @mode developer
 */
const UploadButton: FC<UploadButtonProps & WithTranslation> = ({ children, t, tReady, disabled, onValueChange, onTouched, ...props }) => {
  const { colId } = useContext(FormColContext);
  const fontWeight = useMemo(() => ({ fontWeight: 'bold' }), []);

  return (
    <Upload disabled={disabled} onValueChange={onValueChange} {...props}>
      {({ targetProps, inputProps, accept }) => (
        <TertiaryButton
          as="div"
          outline
          RightIcon={StyledUploadIcon}
          disabled={disabled}
          {...props}
          {...targetProps}
          style={fontWeight}
          data-testid="UploadButton"
        >
          <input
            aria-labelledby={colId}
            {...inputProps}
            accept={accept}
            disabled={disabled}
          />
          <span>{children || t('label')}</span>
        </TertiaryButton>
      )}
    </Upload>
  );
};
UploadButton.defaultProps = UploadButtonDefaultProps;

export default UploadButton;
